// src/components/ResultChart.js

import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

function ResultChart({ data }) {
  return (
    <div style={{ width: '100%', height: 300 }}>
      <h3>자산 성장 그래프</h3>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year"
          label={{
             value: "연도",
             position: "insideBottom", 
             }}
           />
          <YAxis label={{ value: "자산 (만원)", angle: -90, position: "insideLeft" }} />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="nominal" stroke="#8884d8" name="명목 자산" />
          <Line type="monotone" dataKey="real" stroke="#82ca9d" name="실질 자산" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ResultChart;


